<template>

	<div>
		<b-button variant="info" v-b-modal.edit-testuser-modal style="margin-right: 10px">Edit Selected...</b-button>
		<b-modal id="edit-testuser-modal" title="Edit Test User" @ok="handleOk">
			<b-form ref="edit-user-form">
				<b-form-group id="group-ldapAttributes-parameters" label="LDAP Attributes:">
					<b-input-group  class="mb-2">
						<b-form-textarea 
							v-model="ldapAttributes"
							aria-labelledby="group-ldapAttributes-parameters">
						</b-form-textarea>
					</b-input-group> 
				</b-form-group>
				<b-form-group id="group-sisAttributes-parameters" label="SIS Attributes:">
					<b-input-group class="mb-2">
						<b-form-textarea
							v-model="sisAttributes"
							aria-labelledby="group-sisAttributes-parameters">
						</b-form-textarea>
					</b-input-group>
				</b-form-group>
				<b-form-group id="group-upsAttributes-parameters" label="UPS Attributes:">
					<b-input-group class="mb-2">
						<b-form-textarea
							v-model="upsAttributes"
							aria-labelledby="group-upsAttributes-parameters">
						</b-form-textarea>
					</b-input-group>
				</b-form-group>
			</b-form>
		</b-modal>
	</div>

</template>


<script>
/* eslint-disable no-alert, no-console */

const yaml = require('js-yaml')

import {UPDATE_TEST_USER} from '../../store/actions/testusers'
export default {
	name: 'EditTestuser',
	data() {
		return {
			ldapAttributes: '',
			sisAttributes: '',
			upsAttributes: ''
		}
	},
	computed: {},

	props: {
		users: Array
	},
	methods: {
		checkFormValidity() {
			const valid = this.$refs.form.checkValidity()
			this.nameState = valid
		},

		handleOk(modalEvt) {
			modalEvt.preventDefault()
			this.handleSubmit()
		},

		async handleSubmit() {
			if(!this.checkFormValidity) {
				return
			}
			
			//convert an array of entries to a single object
			let editedAttributes = {}
			try {
				editedAttributes['ldap'] = yaml.safeLoad(this.ldapAttributes)
				editedAttributes['sis'] = yaml.safeLoad(this.sisAttributes)
				editedAttributes['ups'] = yaml.safeLoad(this.upsAttributes)
			} catch(error) {
				this.$store.commit("UPDATE_MESSAGE", "Invalid YAML was passed.")
				
				return error
			}
			
			await this.users.map((testuser) => {
				try {
					let payload = {
						editUid: testuser.ldap.uid,
						editAttributes: editedAttributes
					}				
					this.$store.dispatch(UPDATE_TEST_USER, payload)
				} catch(error) {
					return error
				}
			})
			this.$bvModal.hide('edit-testuser-modal')

		}
	}
}
</script>